import { Action } from 'redux';
import { CloseModalAction, OpenModalAction, actionTypes as t } from '../actions';

type ModalState = Record<
  string,
  {
    isOpen: boolean;
    [key: string]: unknown;
  }
>;

export const modalsReducer = (state: ModalState = {}, action: Action) => {
  switch (action.type) {
    case t.OPEN_MODAL: {
      const { modalName, modalProps = {} } = (action as OpenModalAction).payload;
      return {
        ...state,
        [modalName]: { isOpen: true, ...modalProps },
      };
    }
    case t.CLOSE_MODAL: {
      const { modalName } = (action as CloseModalAction).payload;
      return Object.entries(state).reduce(
        (acc, [key, value]) => (modalName === key ? acc : { ...acc, [key]: value }),
        {},
      );
    }
    default:
      return state;
  }
};
